module.exports = __webpack_public_path__ + "static/media/clapper-board.9b0b49f9.svg";